import styled from "styled-components";

export default styled.div`
    td:has(.changedCell) {
        background-color: rgba(255, 193, 7, 0.2);
    }

    .changedCell {
        display: contents;
    }
`;
